import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PAGE_SIZE = 20;

export function Paginator({ skip, total, pageSize = PAGE_SIZE, onChange, testid, busy }) {
  const end = Math.min(skip + pageSize, total);
  return (
    <div className="flex items-center justify-between gap-3 mt-2" data-testid={testid}>
      <p className="text-[11px] text-slate-400" data-testid={`${testid}-summary`}>
        {total === 0 ? "0 records" : `Showing ${skip + 1}–${end} of ${total}`}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" className="h-8 rounded-lg text-xs" data-testid={`${testid}-prev`}
          disabled={busy || skip === 0} onClick={() => onChange(Math.max(0, skip - pageSize))}>
          <ChevronLeft size={14} /> Prev
        </Button>
        <Button variant="outline" size="sm" className="h-8 rounded-lg text-xs" data-testid={`${testid}-next`}
          disabled={busy || end >= total} onClick={() => onChange(skip + pageSize)}>
          Next <ChevronRight size={14} />
        </Button>
      </div>
    </div>
  );
}
